import { render, staticRenderFns } from "./relatorios_estudantes_cadastrados.vue?vue&type=template&id=64979f08&scoped=true&"
import script from "./relatorios_estudantes_cadastrados.vue?vue&type=script&lang=js&"
export * from "./relatorios_estudantes_cadastrados.vue?vue&type=script&lang=js&"
import style0 from "./relatorios_estudantes_cadastrados.vue?vue&type=style&index=0&id=64979f08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64979f08",
  null
  
)

export default component.exports